<template>
  <div>
    <div class="modern-login-container" v-if="showLogin == true">
      <div class="login-wrapper">
        <!-- 左侧品牌展示区 -->
        <div class="brand-section">
          <div class="brand-content">
            <div class="brand-header">
              <h1 class="brand-title">{{ 'IT找活网' }}</h1>
              <p class="brand-subtitle">专业的IT技术社区与副业平台</p>
            </div>
            
            <!-- 3D插画区域 -->
            <div class="illustration">
              <div class="illustration-bg">
                <div class="floating-card card-1">
                  <img src="@/assets/img/create/ic_cooperat.png" class="card-image" alt="合作">
                </div>
                <div class="floating-card card-2">
                  <img src="@/assets/img/create/ic_search.png" class="card-image" alt="搜索">
                </div>
                <div class="floating-card card-3">
                  <img src="@/assets/img/create/ic_welfare.png" class="card-image" alt="福利">
                </div>
                <div class="central-element">
                  <img src="@/assets/img/create/ic_logo.png" class="central-image" alt="Logo">
                </div>
              </div>
            </div>
            
            <!-- 登录后功能介绍 -->
            <div class="features-preview">
              <h3>登录后</h3>
              <div class="feature-list">
                <div class="feature-item">
                  <i class="el-icon-s-order"></i>
                  <span>发布任务 寻找合作伙伴</span>
                </div>
                <div class="feature-item">
                  <i class="el-icon-share"></i>
                  <span>分享内容 获得收益</span>
                </div>
                <div class="feature-item">
                  <i class="el-icon-coin"></i>
                  <span>副业兼职 增加收入</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 右侧登录表单区 -->
        <div class="form-section">
          <!-- 关闭按钮 -->
          <div class="close-btn" @click="closeLogin()">
            <i class="el-icon-close"></i>
          </div>
          
          <!-- 表单头部导航 -->
          <div class="form-header">
            <div class="tab-nav">
              <div 
                class="tab-item" 
                :class="{ active: showPasswordLogin && !showPersonWechatLogin }"
                @click="goAuth('password')"
                v-if="!loginType.password">
                账号密码登录
              </div>
              <div 
                class="tab-item"
                :class="{ active: !showPasswordLogin && !showPersonWechatLogin }"
                @click="goAuth('wechat')"
                v-if="!loginType.wechat">
                微信登录
              </div>
            </div>
            <!-- 注册按钮移到这里 -->
            <div class="register-btn-wrapper">
              <el-button 
                class="register-btn-top"
                type="text"
                @click="goRegister">
                注册账号
              </el-button>
            </div>
          </div>
          
          <!-- 表单内容区 -->
          <div class="form-content">
            <el-form :label-position="labelPosition" :rules="loginRules" :model="loginForm" ref="loginForm">
              
              <!--账号密码登录-->
              <div class="form-body" v-if="showPasswordLogin && !showPersonWechatLogin">
                <el-form-item prop="userName">
                  <el-input 
                    v-model="loginForm.userName" 
                    placeholder="请填写账号/邮箱" 
                    :disabled="loginType.password"
                    size="large"
                    @keyup.enter.native="startLogin">
                  </el-input>
                </el-form-item>
                
                <el-form-item prop="password">
                  <el-input 
                    type="password" 
                    v-model="loginForm.password" 
                    placeholder="请填写登录密码" 
                    :disabled="loginType.password"
                    size="large"
                    @keyup.enter.native="startLogin">
                  </el-input>
                </el-form-item>
                
                <div class="forgot-password">
                  <el-link type="primary" @click="goFindback">忘记密码?</el-link>
                </div>
                
                <el-button 
                  class="submit-btn" 
                  type="primary" 
                  @click="startLogin" 
                  :disabled="loginType.password"
                  size="large">
                  登录
                </el-button>
              </div>

              <!--微信登录-->
              <div v-if="showPersonWechatLogin" class="form-body wechat-login">
                <div id="login_container"></div>
                <Qrcode v-if="wechatOrCode" :text="wechatOrCode" :size="200"/>
              </div>

              <!--微信公众号登录-->
              <div v-if="!showPasswordLogin && !showPersonWechatLogin" class="form-body wechat-official">
                <el-image :src="webConfig.wechatPhoto" style="width: 200px; height: 200px; border-radius: 12px;"></el-image>
                <p class="qr-tip">扫码关注公众号，回复验证码完成登录</p>
                <div class="login-code">
                  <span>登录验证码：</span>
                  <span class="code-text">{{wechatLoginKey.loginKey}}</span>
                  <i class="el-icon-refresh" @click="refreshWechat()"></i>
                </div>
              </div>

              <!-- 更多登录方式 -->
              <!-- <el-collapse :value="webConfig.spreadLoginType == '1'? 'open':''" class="more-login">
                <el-collapse-item name="open">
                  <template slot="title">
                    <span class="more-login-title">其他登录方式</span>
                  </template>
                  
                  <div class="social-login">
                    <el-tooltip content="账号登录" placement="bottom" v-if="!loginType.password">
                      <el-button type="info" circle @click="goAuth('password')" :disabled="loginType.password">
                        <span class="iconfont">&#xe8b2;</span>
                      </el-button>
                    </el-tooltip>

                    <el-tooltip content="码云登录" placement="bottom" v-if="!loginType.gitee">
                      <el-button type="danger" circle @click="goAuth('gitee')" :disabled="loginType.gitee">
                        <span class="iconfont">&#xe602;</span>
                      </el-button>
                    </el-tooltip>

                    <el-tooltip content="Github登录" placement="bottom" v-if="!loginType.github">
                      <el-button type="info" circle @click="goAuth('github')" :disabled="loginType.github">
                        <span class="iconfont">&#xe64a;</span>
                      </el-button>
                    </el-tooltip>

                    <el-tooltip content="QQ登录" placement="bottom" v-if="!loginType.qq">
                      <el-button type="primary" circle @click="goAuth('qq')" :disabled="loginType.qq">
                        <span class="iconfont">&#xe601;</span>
                      </el-button>
                    </el-tooltip>

                    <el-tooltip content="公众号登录" placement="bottom" v-if="!loginType.wechat">
                      <el-button type="success" circle @click="goAuth('wechat')" :disabled="loginType.wechat">
                        <span class="iconfont">&#xe60b;</span>
                      </el-button>
                    </el-tooltip>

                    <el-tooltip content="微信登录" placement="bottom" v-if="!loginType.personWechat">
                      <el-button type="success" circle @click="goAuth('personWechat')" :disabled="loginType.personWechat">
                        <span class="iconfont">&#xe66f;</span>
                      </el-button>
                    </el-tooltip>
                  </div>
                </el-collapse-item>
              </el-collapse> -->
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <!-- 注册弹窗 -->
    <div class="modern-login-container" v-if="showLogin == false && showFindback == false">
      <div class="login-wrapper">
        <!-- 左侧品牌展示区 -->
        <div class="brand-section">
          <div class="brand-content">
            <div class="brand-header">
              <h1 class="brand-title">{{  'IT找活网' }}</h1>
              <p class="brand-subtitle">专业的IT技术社区与找活平台</p>
            </div>
            
            <div class="illustration">
              <div class="illustration-bg">
                <div class="floating-card card-1">
                  <img src="@/assets/img/create/ic_cooperat.png" class="card-image" alt="合作">
                </div>
                <div class="floating-card card-2">
                  <img src="@/assets/img/create/ic_search.png" class="card-image" alt="搜索">
                </div>
                <div class="floating-card card-3">
                  <img src="@/assets/img/create/ic_welfare.png" class="card-image" alt="福利">
                </div>
                <div class="central-element">
                  <img src="@/assets/img/create/ic_logo.png" class="central-image" alt="Logo">
                </div>
              </div>
            </div>
            
            <div class="register-tip">
              <p>注册成为会员，开启您的IT找活之旅</p>
              <p>邮箱验证后即可享受完整功能</p>
            </div>
          </div>
        </div>
        
        <!-- 右侧注册表单区 -->
        <div class="form-section">
          <div class="close-btn" @click="closeLogin()">
            <i class="el-icon-close"></i>
          </div>
          
          <div class="form-header">
            <div class="tab-nav">
              <div class="tab-item" @click="goLogin">登录</div>
              <div class="tab-item active">注册</div>
            </div>
          </div>
          
          <div class="form-content">
            <el-form :rules="rules" :label-position="labelPosition" :model="registerForm" ref="registerForm">
              <div class="form-body">
                <el-form-item prop="userName">
                  <el-input 
                    v-model="registerForm.userName" 
                    placeholder="正确的11位手机号" 
                    :disabled="loginType.password" 
                    size="large"
                    @blur="validateUserName"
                    @input="clearValidateStatus('userName')"
                    @keyup.enter.native="startRegister">
                  </el-input>
                  <div 
                    v-if="validateStatus.userName && validateMessages.userName" 
                    :class="['custom-validate-msg', validateStatus.userName]">
                    {{ validateMessages.userName }}
                  </div>
                </el-form-item>

                <el-form-item prop="nickName">
                  <el-input 
                    v-model="registerForm.nickName" 
                    placeholder="昵称长度在1~20之间" 
                    :disabled="loginType.password" 
                    size="large"
                    @blur="validateNickName"
                    @input="clearValidateStatus('nickName')"
                    @keyup.enter.native="startRegister">
                  </el-input>
                  <div 
                    v-if="validateStatus.nickName && validateMessages.nickName" 
                    :class="['custom-validate-msg', validateStatus.nickName]">
                    {{ validateMessages.nickName }}
                  </div>
                </el-form-item>

                <el-form-item prop="password">
                  <el-input type="password" v-model="registerForm.password" placeholder="密码长度在5~20之间" :disabled="loginType.password" size="large" @keyup.enter.native="startRegister"></el-input>
                </el-form-item>

                <el-form-item prop="password2">
                  <el-input type="password" v-model="registerForm.password2" placeholder="请再次输入密码" :disabled="loginType.password" size="large" @keyup.enter.native="startRegister"></el-input>
                </el-form-item>

                <el-form-item prop="email">
                  <el-input 
                    v-model="registerForm.email" 
                    placeholder="请输入正确的邮箱进行注册认证" 
                    :disabled="loginType.password" 
                    size="large"
                    @blur="validateEmail"
                    @input="clearValidateStatus('email')"
                    @keyup.enter.native="startRegister">
                  </el-input>
                  <div 
                    v-if="validateStatus.email && validateMessages.email" 
                    :class="['custom-validate-msg', validateStatus.email]">
                    {{ validateMessages.email }}
                  </div>
                </el-form-item>
                <el-form-item prop="agreeProtocol" class="protocol-item">
                  <el-checkbox 
                    v-model="registerForm.agreeProtocol" 
                    :disabled="loginType.password"
                    class="protocol-checkbox">
                    我已阅读并同意
                    <a href="javascript:void(0)" @click="showUserProtocol" class="protocol-link">《用户注册协议》</a>
                    和
                    <a href="javascript:void(0)" @click="showPrivacyPolicy" class="protocol-link">《隐私政策》</a>
                  </el-checkbox>
                </el-form-item>

                <el-button class="submit-btn" type="primary" @click="startRegister" :disabled="isRegisterDisabled" size="large">注册</el-button>

              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <!-- 找回密码弹窗 -->
    <div class="modern-login-container" v-if="showFindback == true">
      <div class="login-wrapper">
        <!-- 左侧品牌展示区 -->
        <div class="brand-section">
          <div class="brand-content">
            <div class="brand-header">
              <h1 class="brand-title">{{ webConfig.name || 'IT找活网' }}</h1>
              <p class="brand-subtitle">专业的IT技术社区与副业平台</p>
            </div>
            
            <div class="illustration">
              <div class="illustration-bg">
                <div class="floating-card card-1">
                  <div class="card-icon">🔒</div>
                </div>
                <div class="floating-card card-2">
                  <div class="card-icon">🔑</div>
                </div>
                <div class="floating-card card-3">
                  <div class="card-icon">✉️</div>
                </div>
                <div class="central-element">
                  <div class="tech-cube"></div>
                </div>
              </div>
            </div>
            
            <div class="register-tip">
              <p>重置密码，快速找回账户访问权限</p>
              <p>验证邮箱后即可设置新密码</p>
            </div>
          </div>
        </div>
        
        <!-- 右侧找回密码表单区 -->
        <div class="form-section">
          <div class="close-btn" @click="closeLogin()">
            <i class="el-icon-close"></i>
          </div>
          
          <div class="form-header">
            <div class="tab-nav">
              <div class="tab-item" @click="goLogin">登录</div>
              <div class="tab-item active">找回密码</div>
            </div>
          </div>
          
          <div class="form-content">
            <el-form :rules="findbackRules" :label-position="labelPosition" :model="findbackForm" ref="findbackForm">
              <div class="form-body">

                <el-form-item prop="mobile">
                  <el-input 
                    v-model="findbackForm.mobile" 
                    placeholder="请输入注册时的手机号" 
                    size="large"
                    @blur="validateMobile"
                    @keyup.enter.native="startFindback">
                  </el-input>
                </el-form-item>

                <el-form-item prop="email">
                  <el-input 
                    v-model="findbackForm.email" 
                    placeholder="请输入注册时的邮箱" 
                    size="large"
                    @blur="validateEmailField"
                    @keyup.enter.native="startFindback">
                  </el-input>
                </el-form-item>
                
                <el-form-item prop="password">
                  <el-input type="password" v-model="findbackForm.password" placeholder="密码长度在5~20之间" :disabled="loginType.password" size="large" @keyup.enter.native="startFindback"></el-input>
                </el-form-item>

                <el-form-item prop="password2">
                  <el-input type="password" v-model="findbackForm.password2" placeholder="请再次输入密码" :disabled="loginType.password" size="large" @keyup.enter.native="startFindback"></el-input>
                </el-form-item>

                <el-button class="submit-btn" type="primary" @click="startFindback" size="large">提交</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <div class="mask"></div>
  </div>
</template>

<script>
import {login, localLogin, localRegister, localRegisterCheck, getWechatOrCodeTicket, getUserLoginStatus, getWeChatLoginUrl, findbackPassword} from "@/api/user";
import {getLoginKey,loginCheck } from "@/api/wechat";

import { Loading } from 'element-ui';
import {setCookie} from "@/utils/cookieUtils";
import {mapMutations} from "vuex";
import Qrcode from 'vue-qrcode-component'
export default {
  name: "share",
  data() {
    return {
      loading: null,
      option: {
        fullscreen: true,
        lock: true
      },
      webConfig: {},
      vueMoguWebUrl: process.env.VUE_MOGU_WEB,
      showPasswordLogin: true, // 是否显示账号密码登录
      showPersonWechatLogin: false, // 是否展示微信登录
      showFindback: false, // 是否显示找回密码
      wechatOrCode: "", // 微信公众号登录二维码
      ticket: "", // 用户的票券
      wechatLoginKey: "", // 验证码
      interval: null,
      // 显示登录页面
      showLogin: true,
      isLogin: false,
      table: false,
      dialog: false,
      labelPosition: "right",
      loginForm: {
        userName: "",
        password: ""
      },
      registerForm: {
        userName: "",
        nickName: "",
        password: "",
        password2: "",
        email: "",
        agreeProtocol: false // 用户协议勾选状态
      },
      // 验证状态
      validateStatus: {
        userName: '', // '', 'success', 'error'
        nickName: '',
        email: ''
      },
      validateMessages: {
        userName: '',
        nickName: '',
        email: ''
      },
      findbackForm: {
        email: "",
        mobile: "",
        password: "",
        password2: "",
      },
      // 登录类别
      loginType: {
        password: true,
        gitee: true,
        github: true,
        qq: true,
        wechat: true,
        personWechat: true,
      },
      loginRules: {
        userName: [
          {required: true, message: '请输入手机号或邮箱', trigger: 'blur'},
          {pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|1[3456789]\d{9}$/, message: '请输入正确的手机号或邮箱'},
        ],
        nickName: [
          {required: true, message: '请输入昵称', trigger: 'blur'},
          { min: 1, message: "用户名长度大于等于 1 个字符", trigger: "blur" },
          { max: 20, message: "用户名长度不能大于 20 个字符", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 5, message: "密码长度需要大于等于 5 个字符", trigger: "blur" },
          { max: 20, message: "密码长度不能大于 20 个字符", trigger: "blur" }
        ]
      },
      rules: {
        userName: [
          {required: true, message: '请输入手机号', trigger: 'blur'}
        ],
        nickName: [
          {required: true, message: '请输入昵称', trigger: 'blur'}
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 5, message: "密码长度需要大于等于 5 个字符", trigger: "blur" },
          { max: 20, message: "密码长度不能大于 20 个字符", trigger: "blur" }
        ],
        password2: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { min: 5, message: "密码长度需要大于等于 5 个字符", trigger: "blur" },
          { max: 20, message: "密码长度不能大于 20 个字符", trigger: "blur" }
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" }
        ],
        agreeProtocol: [
          { 
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请阅读并同意用户注册协议'));
              } else {
                callback();
              }
            }, 
            trigger: 'change' 
          }
        ]
      },
      findbackRules: {
        mobile: [
          {required: true, message: '请输入手机号', trigger: ['blur', 'change']},
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: ['blur', 'change']},
        ],
       email: [
          {required: true, message: '请输入邮箱', trigger: ['blur', 'change']},
          {pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: '请输入正确的邮箱', trigger: ['blur', 'change']},
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 5, message: "密码长度需要大于等于 5 个字符", trigger: "blur" },
          { max: 20, message: "密码长度不能大于 20 个字符", trigger: "blur" }
        ],
        password2: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { min: 5, message: "密码长度需要大于等于 5 个字符", trigger: "blur" },
          { max: 20, message: "密码长度不能大于 20 个字符", trigger: "blur" }
        ]
      },
    };
  },
  components: {
    Qrcode
  },
  computed: {
    // 计算注册按钮是否应该禁用
    isRegisterDisabled() {
      return this.loginType.password || 
             this.validateStatus.userName === 'error' || 
             this.validateStatus.nickName === 'error' || 
             this.validateStatus.email === 'error' ||
             !this.registerForm.userName ||
             !this.registerForm.nickName ||
             !this.registerForm.password ||
             !this.registerForm.password2 ||
             !this.registerForm.email;
    }
  },
  created() {
    this.setLoginTypeList()
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setLoginState']),
    setLoginTypeList: function() {
      // 获取登录方式列表
      let webConfigData = this.$store.state.app.webConfigData
      this.webConfig = webConfigData
      if(webConfigData.loginTypeList != undefined) {
        let loginTypeList = JSON.parse(webConfigData.loginTypeList)
        for(let a=0; a<loginTypeList.length; a++) {
          switch (loginTypeList[a]) {
            case "1": {
              this.loginType.password = false
            } break;
            case "2": {
              this.loginType.gitee = false
            } break;
            case "3": {
              this.loginType.github = false
            } break;
            case "4": {
              this.loginType.qq = false
            } break;
            case "5": {
              // 公众号
              this.loginType.wechat = false
            } break;
            case "6": {
              // 个人微信
              this.loginType.personWechat = false
            } break;
            default: {
              console.log("登录方式设置有误！！")
            }
          }
        }

        // 控制一下优先级 1 账号密码 5 微信公众号 7 微信
        let isShow = false
        if(webConfigData.loginPriority) {
          let loginPriority = webConfigData.loginPriority
          isShow = true
          if (loginPriority === "1") {
            this.showPasswordLogin = true
            this.showPersonWechatLogin = false
          }
          if (loginPriority === "5") {
            this.showPasswordLogin = false
            this.showPersonWechatLogin = false
          }
          if (loginPriority === "7") {
            this.showPasswordLogin = false
            this.showPersonWechatLogin = true
          }
        }
        if (!isShow) {
          // 只有当开启微信登录，并且未账号密码时，才主动显示扫码页面
          this.showPasswordLogin = !(this.loginType.password && !this.loginType.wechat)
        }

        if(!this.showPasswordLogin) {
          this.getWechatLoginKey()
        }
      }
    },
    getWeChatLoginUrlMethod() {
      let that = this
      let params = new URLSearchParams()
      params.append("operateType", "login")
      getWeChatLoginUrl(params).then(response => {
        if (response.code === this.$ECode.SUCCESS) {
          console.log("获取微信的信息", response)
          let data = response.data;
          let obj = new WxLogin({
            // 需要显示内嵌二维码的容器id
            id: 'login_container',
            self_redirect:true,
            // 应用ID
            appid: data.appId,
            // 网页默认即可
            scope: data.scope,
            // 授权成功后回调的url
            redirect_uri: encodeURIComponent(data.redirect_uri),
            // 可设置为简单的随机数加session用来校验
            state: data.state,
            // 二维码的样式，提供"black"、"white"可选。
            style: 'black',
            // 自定义样式链接
            href: 'https://oos.moguit.cn/cdn/wechatLogin.css'
          })

          // 开始定时扫描，判断是否完成登录
          let count = 0
          let interval = setInterval(() => {
            count++
            // 当检查15次未扫码的时候，将二维码失效，重试关闭接口请求
            if(count > 30) {
              that.wechatLoginKey.loginKey = "验证码失效,请刷新"
              clearInterval(interval)
            }
            let params = {}
            params.code = data.loginKey
            params.ticket = data.ticket
            loginCheck(params).then(response => {
              console.log("获取用户状态", response)
              if(response.code == that.$ECode.SUCCESS) {
                console.log("获取token", response)
                // 设置token到Cookie中，并刷新页面
                let token = response.data
                if (token) {
                  setCookie("token", token, 31)
                  location.reload();
                }
              }
            });
          }, 3000);

        }
      })
    },
    startLogin: function () {
      // 记录跳转地址，后续登录后做跳转到此页面
      setCookie("redirectUrl", this.$route.path, 1);
      this.$refs.loginForm.validate((valid) => {
        if(!valid) {
          console.log('校验失败')
          return;
        } else {
          let params = {};
          params.userName = this.loginForm.userName;
          params.passWord = this.loginForm.password;
          params.isRememberMe = 1;
          localLogin(params).then(response => {
            if (response.code == this.$ECode.SUCCESS) {
              console.log("登录成功的消息", response)
              // 跳转到首页
              window.location.replace(this.vueMoguWebUrl + "?token=" + response.data.token)
            } else {
              this.$message({
                type: "error",
                message: response.message
              })
            }
          });
        }
      })
    },
    startRegister: function () {
      // 检查是否同意协议
      if (!this.registerForm.agreeProtocol) {
        this.$message({
          type: "warning",
          message: "请先阅读并同意用户注册协议"
        });
        return;
      }
      
      this.$refs.registerForm.validate((valid) => {
        if(!valid) {
          console.log('校验失败')
          return;
        } else {
          // 检查自定义验证状态
          if (this.validateStatus.userName === 'error') {
            this.$message({
              type: "error",
              message: this.validateMessages.userName || "用户名验证失败"
            })
            return;
          }
          
          if (this.validateStatus.nickName === 'error') {
            this.$message({
              type: "error", 
              message: this.validateMessages.nickName || "昵称验证失败"
            })
            return;
          }
          
          if (this.validateStatus.email === 'error') {
            this.$message({
              type: "error",
              message: this.validateMessages.email || "邮箱验证失败"
            })
            return;
          }
          
          let passWord = this.registerForm.password;
          let passWord2 = this.registerForm.password2;
          if(passWord != passWord2) {
            this.$message({
              type: "error",
              message: "两次密码不一致"
            })
            return;
          }
          let params = {};
          params.userName = this.registerForm.userName;
          params.passWord = this.registerForm.password;
          params.email = this.registerForm.email;
          params.nickName = this.registerForm.nickName
          params.virtualOfficeFlag = '0'
          localRegister(params).then(response => {
            if (response.code == this.$ECode.SUCCESS) {
              this.$message({
                type: "success",
                message: response.data
              })
              // 打开登录页面
              this.goLogin();
            } else {
              this.$message({
                type: "error",
                message: response.message
              })
            }
          });
        }
      })
    },
    goLogin: function () {
      this.showLogin = true;
      this.showFindback = false;
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.loginForm) {
          this.$refs.loginForm.clearValidate();
        }
      });
    },
    goRegister: function () {
      this.registerForm.userName="";
      this.registerForm.password="";
      this.registerForm.password2="";
      this.registerForm.email="";
      this.registerForm.agreeProtocol = false; // 重置协议勾选状态
      this.showLogin = false;
      this.showFindback = false;
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.registerForm) {
          this.$refs.registerForm.clearValidate();
        }
      });
    },
    userInfoStatus: function () {
      getUserLoginStatus().then(response => {
        console.log("获取用户状态", response)
      });
    },
    refreshWechat: function () {
      clearInterval(this.interval)
      this.getWechatLoginKey()
      this.$message.success("刷新成功")
    },
    // 获取验证码
    getWechatLoginKey: function () {
      this.showPasswordLogin = false
      let that = this
      getLoginKey().then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          let loginKey = response.data
          this.wechatLoginKey = loginKey
          let count = 0
          let interval = setInterval(() => {
            count++
            // 当检查15次未扫码的时候，将二维码失效，重试关闭接口请求
            if(count > 30) {
              that.wechatLoginKey.loginKey = "验证码失效,请刷新"
              clearInterval(interval)
            }
            let params = {}
            params.code = loginKey.loginKey
            params.ticket = loginKey.ticket
            loginCheck(params).then(response => {
              console.log("获取用户状态", response)
              if(response.code == that.$ECode.SUCCESS) {
                console.log("获取token", response)
                // 判断url中是否含有token
                let token = response.data
                if (token != undefined) {
                  // 设置token七天过期
                  setCookie("token", token, 31)
                  location.reload();
                }
              }
            });
          }, 3000);

          this.interval = interval
        }
      })
    },
    goAuth: function (source) {
      this.showPersonWechatLogin = false
      // 记录跳转地址，后续登录后做跳转到此页面
      setCookie("redirectUrl", this.$route.path, 1);
      // 判断是否点击公众号登录
      if(source === "wechat") {
        console.log("点击公众号登录")
        this.getWechatLoginKey()
        return
      }
      if(source === "password") {
        console.log("点击账号密码登录")
        this.showPersonWechatLogin = false
        this.showPasswordLogin = true
        return
      }
      if(source === "personWechat") {
        this.showPersonWechatLogin = true
        console.log("点击微信登录")
        this.getWeChatLoginUrlMethod()
        return
      }
      this.loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = new URLSearchParams();
      params.append("source", source);
      params.append("type", "login");
      login(params).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          window.location.href = response.data.url
        }
      });
    },
    closeLogin: function() {
      this.$emit("closeLoginBox", "");
    },
    goFindback: function () {
      this.findbackForm.mobile = "";
      this.findbackForm.email = "";
      this.findbackForm.password = "";
      this.findbackForm.password2 = "";
      this.showLogin = false;
      this.showFindback = true;
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.findbackForm) {
          this.$refs.findbackForm.clearValidate();
        }
      });
    },
    startFindback: function () {
      this.$refs.findbackForm.validate((valid) => {
        if(!valid) {
          console.log('校验失败')
          return;
        } else {
          let params = {};
          params.email = this.findbackForm.email;
          params.mobile = this.findbackForm.mobile;
          let passWord = this.findbackForm.password;
          let passWord2 = this.findbackForm.password2;
          if(passWord != passWord2) {
            this.$message({
              type: "error",
              message: "两次密码不一致"
            })
            return;
          }
          params.passWord = this.findbackForm.password;
          findbackPassword(params).then(response => {
            if (response.code == this.$ECode.SUCCESS) {
              this.$message({
                type: "success",
                message: response.data
              })
              // 返回登录页面
              this.goLogin();
            } else {
              this.$message({
                type: "error",
                message: response.data
              })
            }
          });
        }
      })
    },
    validateUserName: function () {
      // 清除之前的状态
      this.validateStatus.userName = '';
      this.validateMessages.userName = '';
      
      // 验证用户名格式
      if (!this.registerForm.userName) {
        return;
      }
      
      // 检查手机号格式
      const phoneRegex = /^1[3456789]\d{9}$/;
      if (!phoneRegex.test(this.registerForm.userName)) {
        this.validateStatus.userName = 'error';
        this.validateMessages.userName = '请输入正确的手机号';
        return;
      }

      // 调用验证接口
      let params = {
        userName: this.registerForm.userName
      };
      
      localRegisterCheck(params).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          this.validateStatus.userName = 'success';
          this.validateMessages.userName = '手机号可以使用';
        } else {
          this.validateStatus.userName = 'error';
          this.validateMessages.userName = response.message;
        }
      }).catch(error => {
        console.error("用户名验证失败:", error);
        this.validateStatus.userName = 'error';
        this.validateMessages.userName = '验证失败，请重试';
      });
    },
    validateNickName: function () {
      // 清除之前的状态
      this.validateStatus.nickName = '';
      this.validateMessages.nickName = '';
      
      // 验证昵称格式
      if (!this.registerForm.nickName) {
        return;
      }
      
      // 检查昵称长度
      if (this.registerForm.nickName.length < 1 || this.registerForm.nickName.length > 20) {
        this.validateStatus.nickName = 'error';
        this.validateMessages.nickName = '昵称长度需要在1-20个字符之间';
        return;
      }

      // 调用验证接口
      let params = {
        nickName: this.registerForm.nickName
      };
      
      localRegisterCheck(params).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          this.validateStatus.nickName = 'success';
          this.validateMessages.nickName = '昵称可以使用';
        } else {
          this.validateStatus.nickName = 'error';
          this.validateMessages.nickName = response.message;
        }
      }).catch(error => {
        console.error("昵称验证失败:", error);
        this.validateStatus.nickName = 'error';
        this.validateMessages.nickName = '验证失败，请重试';
      });
    },
    validateEmail: function () {
      // 清除之前的状态
      this.validateStatus.email = '';
      this.validateMessages.email = '';
      
      // 验证邮箱格式
      if (!this.registerForm.email) {
        return;
      }
      
      // 检查邮箱格式
      const emailRegex = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      if (!emailRegex.test(this.registerForm.email)) {
        this.validateStatus.email = 'error';
        this.validateMessages.email = '请输入正确的邮箱';
        return;
      }

      // 调用验证接口
      let params = {
        email: this.registerForm.email
      };
      
      localRegisterCheck(params).then(response => {
        if (response.code == this.$ECode.SUCCESS) {
          this.validateStatus.email = 'success';
          this.validateMessages.email = '邮箱可以使用';
        } else {
          this.validateStatus.email = 'error';
          this.validateMessages.email = response.message;
        }
      }).catch(error => {
        console.error("邮箱验证失败:", error);
        this.validateStatus.email = 'error';
        this.validateMessages.email = '验证失败，请重试';
      });
    },
    validateMobile: function () {
      // 手动触发表单验证
      this.$nextTick(() => {
        if (this.$refs.findbackForm) {
          this.$refs.findbackForm.validateField('mobile', (errorMessage) => {
            if (errorMessage) {
              console.log('手机号验证失败:', errorMessage);
            }
          });
        }
      });
    },
    validateEmailField: function () {
      // 手动触发表单验证
      this.$nextTick(() => {
        if (this.$refs.findbackForm) {
          this.$refs.findbackForm.validateField('email', (errorMessage) => {
            if (errorMessage) {
              console.log('邮箱验证失败:', errorMessage);
            }
          });
        }
      });
    },
    clearValidateStatus: function (field) {
      this.validateStatus[field] = '';
      this.validateMessages[field] = '';
    },
    
    // 显示用户注册协议
    showUserProtocol: function() {
      // 跳转到独立的用户协议页面
      window.open('/user-agreement', '_blank');
    },
    
    // 显示隐私政策
    showPrivacyPolicy: function() {
      // 跳转到独立的隐私政策页面
      window.open('/privacy-policy', '_blank');
    },
  }
};
</script>

<style scoped>
/* 遮罩层 */
.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  animation: fadeIn 0.3s ease;
}

/* 现代化登录容器 */
.modern-login-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 101;
}

.login-wrapper {
  width: 900px;
  height: 600px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  display: flex;
  overflow: hidden;
  animation: slideIn 0.4s ease-out;
}

/* 左侧品牌展示区 */
.brand-section {
  width: 45%;
  background: #4285f4;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.brand-content {
  text-align: center;
  color: white;
  z-index: 2;
  position: relative;
}

.brand-header h1.brand-title {
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
}

.brand-header p.brand-subtitle {
  font-size: 16px;
  opacity: 0.9;
  margin: 0 0 40px 0;
  font-weight: 300;
}

/* 3D插画区域 */
.illustration {
  margin: 40px 0;
  position: relative;
  height: 200px;
}

.illustration-bg {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.floating-card {
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  animation: float 3s ease-in-out infinite;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.card-1 {
  top: 20px;
  left: 20px;
  animation-delay: 0s;
}

.card-2 {
  top: 20px;
  right: 20px;
  animation-delay: 1s;
}

.card-3 {
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: 2s;
}

.card-image {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.central-element {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  animation: rotate 4s linear infinite;
}

.central-image {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

/* 登录后功能介绍 */
.features-preview h3 {
  font-size: 18px;
  margin: 40px 0 20px 0;
  font-weight: 600;
}

.feature-list {
  text-align: left;
  max-width: 250px;
  margin: 0 auto;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  opacity: 0.9;
}

.feature-item i {
  margin-right: 12px;
  font-size: 16px;
  width: 20px;
}

.register-tip {
  margin-top: 60px;
}

.register-tip p {
  font-size: 14px;
  opacity: 0.8;
  margin: 0 0 8px 0;
}

/* 右侧表单区域 */
.form-section {
  width: 55%;
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  background: #f5f5f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
}

.close-btn:hover {
  background: #e0e0e0;
  transform: rotate(90deg);
}

.close-btn i {
  font-size: 14px;
  color: #666;
}

/* 表单头部 */
.form-header {
  padding: 40px 40px 0;
  position: relative;
}

.tab-nav {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 40px;
  padding-right: 100px; /* 为注册按钮留出空间 */
}

.tab-item {
  padding: 0 0 16px 0;
  margin-right: 40px;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  position: relative;
  transition: color 0.3s ease;
}

.tab-item:hover {
  color: #4285f4;
}

.tab-item.active {
  color: #4285f4;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #4285f4;
  border-radius: 1px;
}

/* 注册按钮包装器 */
.register-btn-wrapper {
  position: absolute;
  top: 40px;
  right: 80px; /* 避开关闭按钮 */
}

.register-btn-top {
  color: #4285f4;
  font-size: 14px;
  padding: 0;
  border: none;
  background: none;
  text-decoration: none;
}

.register-btn-top:hover {
  color: #3367d6;
  text-decoration: underline;
}

/* 表单内容 */
.form-content {
  flex: 1;
  padding: 0 40px 40px;
  display: flex;
  flex-direction: column;
}

.form-body {
  /* 移除flex: 1，让表单项自然排列 */
}

/* 表单项样式重置 */
.form-body .el-form-item {
  margin-bottom: 16px; /* 减少默认间距 */
  position: relative;
  min-height: auto; /* 移除固定高度，让表单项自适应 */
}

/* 为有验证消息的表单项预留空间 */
.form-body .el-form-item.has-validation {
  min-height: 72px; /* 48px输入框 + 24px验证消息空间 */
}

.form-body .el-form-item__label {
  display: none;
}

.form-body .el-form-item__content {
  margin-left: 0 !important;
}

/* 成功状态的样式 */
.form-body .el-form-item.is-success .el-form-item__error {
  color: #67c23a !important;
}

.form-body .el-form-item.is-success .el-input__inner {
  border-color: #67c23a;
}

.form-body .el-form-item.is-success .el-input__inner:focus {
  border-color: #67c23a;
  box-shadow: 0 0 0 3px rgba(103, 194, 58, 0.1);
}

/* 错误状态的样式 */
.form-body .el-form-item.is-error .el-form-item__error {
  color: #f56c6c !important;
  display: block !important;
}

.form-body .el-form-item.is-error .el-input__inner {
  border-color: #f56c6c;
}

.form-body .el-form-item.is-error .el-input__inner:focus {
  border-color: #f56c6c;
  box-shadow: 0 0 0 3px rgba(245, 108, 108, 0.1);
}

/* 输入框样式 */
.form-body .el-input__inner {
  height: 48px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 16px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: #fafafa;
}

.form-body .el-input__inner:focus {
  border-color: #4285f4;
  background: white;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
}

.form-body .el-input__inner::placeholder {
  color: #aaa;
}

/* 忘记密码链接 */
.forgot-password {
  text-align: right;
  margin-bottom: 32px;
}

.forgot-password .el-link {
  font-size: 14px;
  color: #4285f4;
}

/* 提交按钮 */
.submit-btn {
  width: 100%;
  height: 48px;
  background: #4285f4;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  margin-top: 16px; /* 减少按钮上边距 */
}

.submit-btn:hover {
  background: #3367d6;
}

/* 微信登录样式 */
.wechat-login,
.wechat-official {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.qr-tip {
  margin: 20px 0 16px;
  color: #666;
  font-size: 14px;
}

.login-code {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.code-text {
  color: #f56565;
  font-weight: 600;
}

.login-code .el-icon-refresh {
  cursor: pointer;
  color: #4285f4;
  font-size: 16px;
  transition: transform 0.3s ease;
}

.login-code .el-icon-refresh:hover {
  transform: rotate(180deg);
}

/* 用户协议样式 */
.protocol-item {
  margin: 8px 0 8px 0 !important; /* 减少协议项的上下间距 */
  min-height: auto !important; /* 协议项不需要预留验证消息空间 */
}

.protocol-checkbox {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.protocol-checkbox .el-checkbox__label {
  padding-left: 8px;
}

.protocol-link {
  color: #4285f4;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.protocol-link:hover {
  color: #3367d6;
  text-decoration: underline;
}

/* 注册按钮禁用状态 */
.submit-btn:disabled {
  background-color: #c0c4cc !important;
  border-color: #c0c4cc !important;
  color: #ffffff !important;
  cursor: not-allowed !important;
}

/* 更多登录方式 */
.more-login {
  margin-top: 32px;
  border: none;
}

.more-login .el-collapse-item__header {
  background: transparent;
  border: none;
  padding: 0;
  height: auto;
  line-height: 1.5;
}

.more-login-title {
  color: #999;
  font-size: 14px;
}

.more-login .el-collapse-item__wrap {
  border: none;
}

.more-login .el-collapse-item__content {
  padding: 20px 0 0;
}

.social-login {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.social-login .el-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  padding: 0;
}

.social-login .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.social-login .iconfont {
  font-size: 16px;
}

/* 微信登录iframe */
#login_container iframe {
  border-radius: 8px;
}

/* 二维码样式 */
.wechat-login canvas,
.wechat-official canvas {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

@keyframes rotate {
  from { transform: translate(-50%, -50%) rotate(0deg); }
  to { transform: translate(-50%, -50%) rotate(360deg); }
}

/* 自定义验证消息样式 - 模仿Element UI的错误提示样式 */
.custom-validate-msg {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  transition: all 0.3s;
  transform-origin: 0 0;
  animation: fadeInUp 0.3s;
}

.custom-validate-msg.success {
  color: #67c23a;
}

.custom-validate-msg.error {
  color: #f56c6c;
}

/* 成功消息动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/LoginBox/index.vue